import React from 'react';
import radium from 'radium';
import questionImage from '../../static/images/questions.png';

const styles = {
  wrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'calc(100vh - 150px)',
    padding: 20,
  },
  image: {
    maxWidth: '100%',
    maxHeight: 'calc(100% - 60px)',
  },
};

function Questions() {
  return (
    <div style={styles.wrap}>
      <img role="presentation" src={questionImage} style={styles.image} />
    </div>
  );
}

export default radium(Questions);



// WEBPACK FOOTER //
// ./components/Questions/Questions.js